<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <div>
        <h2>成交报告与佣金核算</h2>
        <p>
          成交数据直接读取原
          transaction、tran_com_all；财务表只保存管理员确认的核算快照
        </p>
      </div>
      <el-button
        :loading="loading"
        @click="load"
      >
        刷新
      </el-button>
    </div>
    <el-card shadow="never">
      <div class="filters">
        <el-select
          v-model="filters.status"
          clearable
          placeholder="全部状态"
          @change="reload"
        >
          <el-option
            label="待审核"
            value="UNDER_REVIEW"
          />
          <el-option
            label="已审核"
            value="APPROVED"
          />
          <el-option
            label="审核未通过"
            value="REVIEW_FAILED"
          />
        </el-select>
      </div>
      <el-table
        v-loading="loading"
        :data="rows"
        stripe
      >
        <el-table-column
          type="expand"
          width="48"
        >
          <template #default="{ row }">
            <div class="expanded">
              <el-descriptions
                :column="3"
                border
                size="small"
              >
                <el-descriptions-item label="成交编号">
                  {{ row.id }}
                </el-descriptions-item>
                <el-descriptions-item label="付款方">
                  {{ row.com_payer || '-' }}
                </el-descriptions-item>
                <el-descriptions-item label="支付方式">
                  {{ row.com_pay_method || '-' }}
                </el-descriptions-item>
                <el-descriptions-item label="收款方">
                  {{ row.com_payee || '-' }}
                </el-descriptions-item>
                <el-descriptions-item label="分配合计">
                  ¥ {{ money(row.allocated_amount) }}
                </el-descriptions-item>
                <el-descriptions-item label="备注">
                  {{ row.note || '-' }}
                </el-descriptions-item>
              </el-descriptions>
              <h4>原成交人员分配</h4>
              <el-table
                :data="row.participants || []"
                size="small"
                border
                empty-text="没有分配明细"
              >
                <el-table-column
                  prop="user_id"
                  label="员工ID"
                  width="90"
                />
                <el-table-column
                  prop="name"
                  label="参与人"
                  min-width="120"
                />
                <el-table-column
                  prop="role"
                  label="角色"
                  width="120"
                />
                <el-table-column
                  label="分配比例"
                  width="110"
                >
                  <template #default="{ row: item }">
                    {{ item.pro_per == null ? '-' : `${item.pro_per}%` }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="分配金额"
                  width="140"
                >
                  <template #default="{ row: item }">
                    ¥ {{ money(item.amount) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="签名状态"
                  width="110"
                >
                  <template #default="{ row: item }">
                    <el-tag :type="item.confirm ? 'success' : 'warning'">
                      {{ item.confirm ? '已签名' : '待签名' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="confirm_time"
                  label="签名时间"
                  min-width="170"
                />
              </el-table>
              <template v-if="row.finance">
                <h4>财务核算快照</h4>
                <el-descriptions
                  :column="4"
                  border
                  size="small"
                >
                  <el-descriptions-item label="核算状态">
                    {{ financeStatus(row.finance.status) }}
                  </el-descriptions-item>
                  <el-descriptions-item label="个人应发">
                    ¥ {{ money(row.finance.personal_base) }}
                  </el-descriptions-item>
                  <el-descriptions-item label="公司分成池">
                    ¥ {{ money(row.finance.company_pool) }}
                  </el-descriptions-item>
                  <el-descriptions-item label="组长奖金">
                    ¥ {{ money(row.finance.leader_bonus) }}
                  </el-descriptions-item>
                </el-descriptions>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="id"
          label="编号"
          width="75"
        />
        <el-table-column
            prop="com_time"
            label="收佣时间"
          width="170"
        />
        <el-table-column
          prop="tran_point"
          label="成交分部"
          width="130"
        />
        <el-table-column
          prop="customer_name"
          label="客户"
          min-width="120"
        />
        <el-table-column
          prop="housing_number"
          label="房源编号"
          min-width="120"
        />
        <el-table-column
          label="应收佣金"
          width="130"
        >
          <template #default="{ row }">
            ¥ {{ money(row.receivable_amount) }}
          </template>
        </el-table-column>
        <el-table-column
          label="原分配合计"
          width="135"
        >
          <template #default="{ row }">
            ¥ {{ money(row.allocated_amount) }}
          </template>
        </el-table-column>
        <el-table-column
          label="成交状态"
          width="105"
        >
          <template #default="{ row }">
            <el-tag :type="tagType(row.status)">
              {{ statusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="财务状态"
          width="110"
        >
          <template #default="{ row }">
            <el-tag :type="financeTag(row.finance?.status)">
              {{ financeStatus(row.finance?.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="200"
          fixed="right"
        >
          <template #default="{ row }">
            <el-button
              v-if="
                row.status === 'APPROVED' &&
                (!row.finance || row.finance.status === 'DRAFT')
              "
              link
              type="primary"
              @click="openPrepare(row)"
            >
              {{ row.finance ? '重新核算' : '佣金核算' }}
            </el-button>
            <el-button
              v-if="row.finance?.status === 'DRAFT'"
              link
              type="success"
              @click="confirmCommission(row)"
            >
              确认
            </el-button>
            <el-button
              v-if="row.finance?.status === 'CONFIRMED'"
              link
              type="danger"
              @click="voidCommission(row)"
            >
              作废
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-empty
        v-if="!loading && !rows.length"
        description="暂无成交报告"
      />
      <div class="pager">
        <el-pagination
          v-model:current-page="page"
          v-model:page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
          @current-change="load"
          @size-change="reload"
        />
      </div>
    </el-card>
    <el-dialog
      v-model="prepareVisible"
      title="成交佣金核算"
      width="560px"
    >
      <el-alert
        type="info"
        :closable="false"
        title="系统按成交日期选择启用方案，并以原 tran_com_all 分配金额逐人计算。"
      />
      <el-form
        :model="prepareForm"
        label-width="130px"
        class="dialog-form"
      >
        <el-form-item label="成交记录">
          #{{ current?.id }} {{ current?.customer_name }}
        </el-form-item>
        <el-form-item
          label="成交分部"
          required
        >
          <el-select
            v-model="prepareForm.organizationUnitId"
            style="width: 100%"
            placeholder="请选择"
          >
            <el-option
              v-for="branch in branches"
              :key="branch.id"
              :label="branch.name"
              :value="branch.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="外部合作分成">
          <el-input-number
            v-model="prepareForm.externalPartnerAmount"
            :min="0"
            :precision="4"
            :controls="false"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="prepareVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saving"
          @click="prepare"
        >
          计算并保存草稿
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { organizationApi, transactionApi } from '../api'

const rows = ref([])
const branches = ref([])
const loading = ref(false)
const saving = ref(false)
const prepareVisible = ref(false)
const current = ref(null)
const page = ref(1)
const pageSize = ref(20)
const total = ref(0)
const filters = reactive({ status: '' })
const prepareForm = reactive({
  organizationUnitId: null,
  externalPartnerAmount: 0,
})
const money = (value) =>
  Number(value || 0).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
const statusText = (status) =>
  ({ UNDER_REVIEW: '待审核', APPROVED: '已审核', REVIEW_FAILED: '未通过' }[
    status
  ] ||
  status ||
  '未知')
const tagType = (status) =>
  ({ UNDER_REVIEW: 'warning', APPROVED: 'success', REVIEW_FAILED: 'danger' }[
    status
  ] || 'info')
const financeStatus = (status) =>
  ({
    DRAFT: '待确认',
    CONFIRMED: '已核算',
    VOID: '已作废',
    LEGACY: '历史待补充',
  }[status] || '未核算')
const financeTag = (status) =>
  ({ DRAFT: 'warning', CONFIRMED: 'success', VOID: 'danger', LEGACY: 'info' }[
    status
  ] || 'info')
const load = async () => {
  loading.value = true
  try {
    const data = await transactionApi.list({
      page: page.value,
      pageSize: pageSize.value,
      status: filters.status,
    })
    rows.value = data.items || []
    total.value = data.total || 0
  } catch (error) {
    ElMessage.error(error?.message || '成交数据加载失败')
  } finally {
    loading.value = false
  }
}
const reload = () => {
  page.value = 1
  load()
}
const openPrepare = (row) => {
  current.value = row
  prepareForm.organizationUnitId =
    row.finance?.organization_unit_id ||
    row.organization_unit_id ||
    branches.value.find((item) => item.name === row.tran_point)?.id ||
    null
  prepareForm.externalPartnerAmount = Number(
    row.finance?.external_partner_amount || 0
  )
  prepareVisible.value = true
}
const prepare = async () => {
  if (!prepareForm.organizationUnitId)
    return ElMessage.warning('请选择成交分部')
  saving.value = true
  try {
    await transactionApi.prepare(current.value.id, { ...prepareForm })
    ElMessage.success('核算草稿已保存')
    prepareVisible.value = false
    await load()
  } catch (error) {
    ElMessage.error(error?.message || '佣金核算失败')
  } finally {
    saving.value = false
  }
}
const confirmCommission = async (row) => {
  try {
    await ElMessageBox.confirm(
      '确认后立即生成员工佣金和组长奖金应发，是否继续？',
      '确认核算'
    )
    await transactionApi.confirm(row.finance.id)
    ElMessage.success('佣金核算已确认')
    await load()
  } catch (error) {
    if (error !== 'cancel') ElMessage.error(error?.message || '确认失败')
  }
}
const voidCommission = async (row) => {
  try {
    const { value } = await ElMessageBox.prompt('请输入作废原因', '作废核算', {
      inputValidator: (text) => !!text || '原因不能为空',
    })
    await transactionApi.void(row.finance.id, { reason: value })
    ElMessage.success('核算已作废')
    await load()
  } catch (error) {
    if (error !== 'cancel') ElMessage.error(error?.message || '作废失败')
  }
}
onMounted(async () => {
  branches.value = await organizationApi.branches().catch(() => [])
  load()
})
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
  color: #1e293b;
}
.page-head p {
  color: #8a97a8;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
.filters {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}
.expanded {
  padding: 12px 32px 20px;
  background: #f8fafc;
}
.expanded h4 {
  margin: 18px 0 10px;
  color: #334155;
}
.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}
.dialog-form {
  margin-top: 18px;
}
</style>
